import styled from 'styled-components'
import { H2, H6 } from '@components/Text'
import SMBContainer from '@components/Container'
import getBreakpoint from '@client/utils/breakpoints'

export const MainWrapper = styled.section`
  padding-top: 40px;
  padding-bottom: 98px;
  background-color: var(--white);
  @media (min-width: ${getBreakpoint('md')}px) {
    padding-top: 72px;
    padding-bottom: 105px;
  }
`

export const Container = styled(SMBContainer)`
  @media (min-width: ${getBreakpoint('md')}px) {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const Title = styled(H2)`
  font-style: normal;
  font-weight: 900;
  line-height: 37px;
  font-family: Rubik;
`

export const Subtitle = styled(H6)`
  font-style: normal;
  font-weight: normal;
  margin-top: 16px;
  margin-bottom: 48px;
  font-family: Rubik;
  @media (min-width: ${getBreakpoint('md')}px) {
    margin-top: 8px;
    margin-bottom: 56px;
  }
`
export const WarningContainer = styled('div')`
  height: 32px;
  top: 148px;
  left: 384px;
  border-radius: 8px;
  background: #fcd6c3;
  margin-bottom: 48px;

  color: #231b22;
  font-weight: bold;
  text-align: center;
  font-size: 15px;
  line-height: 12px;
  font-family: Rubik;

  a {
    color: #231b22;
  }
`

export const Warning = styled('p')`
  margin: auto;
  line-height: 16px;

  @media (min-width: ${getBreakpoint('md')}px) {
    margin: auto;
    line-height: 32px;
  }
`
